import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CloseIcon } from 'components/icons';
import { ButtonsProps } from '../types';

export const CancelButton: FC<ButtonsProps> = (props) => {
  const { t } = useTranslation('translation');

  return (
    <Button type="text" icon={<CloseIcon />} {...props}>
      {t('Cancel')}
    </Button>
  );
};
